import React from 'react';
import { useLaunchUrl, useLaunchActivity } from '../contexts/LaunchContext';

/**
 * Higher-Order Component to inject getLaunchUrl into class components
 * Usage: export default withLaunchUrl(MyClassComponent);
 */
export const withLaunchUrl = (WrappedComponent) => {
  const WithLaunchUrlComponent = (props) => {
    const getLaunchUrl = useLaunchUrl();
    
    return <WrappedComponent {...props} getLaunchUrl={getLaunchUrl} />;
  };
  
  WithLaunchUrlComponent.displayName = `withLaunchUrl(${WrappedComponent.displayName || WrappedComponent.name})`;
  
  return WithLaunchUrlComponent;
};

/**
 * Higher-Order Component to inject launchActivity into class components
 * Usage: export default withLaunchActivity(MyClassComponent);
 */
export const withLaunchActivity = (WrappedComponent) => {
  const WithLaunchActivityComponent = (props) => {
    const launchActivity = useLaunchActivity();
    
    return <WrappedComponent {...props} launchActivity={launchActivity} />;
  };
  
  WithLaunchActivityComponent.displayName = `withLaunchActivity(${WrappedComponent.displayName || WrappedComponent.name})`;
  
  return WithLaunchActivityComponent;
};

/**
 * Higher-Order Component to inject both getLaunchUrl and launchActivity into class components
 * Usage: export default withLaunchFunctions(MyClassComponent);
 */
export const withLaunchFunctions = (WrappedComponent) => {
  const WithLaunchFunctionsComponent = (props) => {
    const getLaunchUrl = useLaunchUrl();
    const launchActivity = useLaunchActivity();
    
    return <WrappedComponent {...props} getLaunchUrl={getLaunchUrl} launchActivity={launchActivity} />;
  };
  
  WithLaunchFunctionsComponent.displayName = `withLaunchFunctions(${WrappedComponent.displayName || WrappedComponent.name})`;
  
  return WithLaunchFunctionsComponent;
};

export default withLaunchUrl;
